import React, { useState } from "react";
import MyImage from "../imgs/about.jpg";
import { FaLightbulb } from "react-icons/fa";
import { PiSuitcaseSimpleBold } from "react-icons/pi";
import { BiSupport } from "react-icons/bi";
import { FiDownloadCloud } from "react-icons/fi";

const About = () => {
  const [counterOn, setCounterOn] = useState(false);
  const [animationOn, setAnimationOn] = useState(false);

  return (
    <>
      <div className="about" id="about">
        <h1 className="mainHeading">ABOUT ME</h1>
        <p className="mainPara">My Introduction</p>
        <div className="aboutContent">
          <div className="aboutRight">
            <img
              className="animate__animated animate__fadeInLeft"
              src={MyImage}
              alt=""
            />
          </div>
          <div className="aboutLeft">
           <div className="aboutTabs animate__animated animate__fadeInRight">
              <div className="aboutTab">
                <FaLightbulb className="tabIcon" />
                <h5 className="tabHeading">Learning</h5>
                <p className="tabPara">Always Exploring</p>
              </div>
              <div className="aboutTab">
                <PiSuitcaseSimpleBold className="tabIcon" />
                <h5 className="tabHeading">Projects</h5>
                <p className="tabPara">10+ Academic Projects</p>
              </div>
              <div className="aboutTab">
                <BiSupport className="tabIcon" />
                <h5 className="tabHeading">Availability</h5>
                <p className="tabPara">Ready to Collaborate</p>
              </div>
            </div>

            <p className="aboutPara animate__animated animate__fadeInUp">
              I'm Emily Han, a product builder and AI enthusiast who combines
              technical expertise with creative problem-solving. She's
              passionate about creating innovative solutions that enhance human
              experiences, especially in the areas of AI/ML, mobile development,
              and game design.
            </p>
            <a href="resume.png" download="resume.png">
              <button className="mainBtn aboutBtn animate__animated animate__fadeInUp">
                Get Resume
                <FiDownloadCloud className="btnIcon" />
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
